import request from '../../utils/requests'
/** * Tag: OrgConfig */
const baseUrl ="/api/OrgConfig";

/** * 设置配置信息 * @param {*} body * { *    DicGroup Desc:分组必填(机构基础设置：OrgBaseSetting) Required:true *    DicValue Desc:DicValue必填
退回公海客户：ReturnCommonSeaDays
不用退回公海的客户状态：NotReturnCommonSeaStatus
续费预警：课时剩余次数：RenewalWarningTimes
续费预警：有效期剩余天数：RenewalWarningDays Required:true *    ConfigValue Desc:配置值必填 Required:true *    BranchId Desc:(只有校区可设置，必填)校区时传当前登陆的校区ID Required:true * } */async function _setConfigValue(body) {  return request(baseUrl+'/setConfigValue',{    method: 'POST',    body: body,  });
}

/** * 获取机构配置Model * @param {*} body * { *    DicGroup Desc:分组必填(机构基础设置：OrgBaseSetting) Required:true *    DicValue Desc:DicValue，可不填
退回公海客户：ReturnCommonSeaDays
不用退回公海的客户状态：NotReturnCommonSeaStatus
续费预警：课时剩余次数：RenewalWarningTimes
续费预警：有效期剩余天数：RenewalWarningDays Required:false *    BranchId Desc:校区时传当前登陆的校区ID，机构时不传 Required:true * } */async function _getModel(body) {  return request(baseUrl+'/getModel',{    method: 'POST',    body: body,  });
}

/** * 获取多个配置 * @param {*} body * { *    req Desc: Required:true * } */async function _getList(body) {  return request(baseUrl+'/getList',{    method: 'POST',    body: body,  });
}

export default{  _setConfigValue,  _getModel,  _getList}



// WEBPACK FOOTER //
// ./src/services/orgConfig.js